"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// FIXME(ndhoule): This typing is not perfect, but I couldn't figure out how else to generate this.
var sites = {
  'garbanzo-api': {
    development: {
      protocol: 'http',
      uri: 'api.goodeggs.test',
      port: 3000
    },
    test: {
      protocol: 'http',
      uri: 'api.goodeggs.test',
      port: 3001
    },
    staging: {
      protocol: 'https',
      uri: 'api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'api.goodeggs.com'
    }
  },
  garbanzo: {
    development: {
      protocol: 'http',
      uri: 'www.goodeggs.test',
      port: 3000
    },
    test: {
      protocol: 'http',
      uri: 'www.goodeggs.test',
      port: 3001
    },
    staging: {
      protocol: 'https',
      uri: 'www.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'www.goodeggs.com'
    }
  },
  manage: {
    development: {
      protocol: 'http',
      uri: 'manage.goodeggs.test',
      port: 3010
    },
    test: {
      protocol: 'http',
      uri: 'manage.goodeggs.test',
      port: 3011
    },
    staging: {
      protocol: 'https',
      uri: 'manage.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'manage.goodeggs.com'
    }
  },
  'manage-api': {
    development: {
      protocol: 'http',
      uri: 'manage.goodeggs.test',
      port: 3010,
      path: '/api'
    },
    test: {
      protocol: 'http',
      uri: 'manage.goodeggs.test',
      port: 3011,
      path: '/api'
    },
    staging: {
      protocol: 'https',
      uri: 'manage.huevosbuenos.com',
      path: '/api'
    },
    production: {
      protocol: 'https',
      uri: 'manage.goodeggs.com',
      path: '/api'
    }
  },
  kale: {
    development: {
      protocol: 'https',
      uri: 'ops.goodeggs.test',
      port: 8000
    },
    test: {
      protocol: 'https',
      uri: 'ops-test.goodeggs.test',
      port: 8001
    },
    staging: {
      protocol: 'https',
      uri: 'ops.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops.goodeggs.com'
    }
  },
  'ops-employees-ui': {
    development: {
      protocol: 'https',
      uri: 'ops-employees.goodeggs.test',
      port: 8005
    },
    test: {
      protocol: 'https',
      uri: 'ops-employees-test.goodeggs.test',
      port: 8006
    },
    staging: {
      protocol: 'https',
      uri: 'ops-employees.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops-employees.goodeggs.com'
    }
  },
  'employees-ui': {
    development: {
      protocol: 'https',
      uri: 'employees.goodeggs.test',
      port: 8005
    },
    test: {
      protocol: 'https',
      uri: 'employees-test.goodeggs.test',
      port: 8006
    },
    staging: {
      protocol: 'https',
      uri: 'employees.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'employees.goodeggs.com'
    }
  },
  'ops-employees-api': {
    development: {
      protocol: 'https',
      uri: 'ops-employees-api.goodeggs.test',
      port: 8010
    },
    test: {
      protocol: 'https',
      uri: 'ops-employees-api-test.goodeggs.test',
      port: 8011
    },
    staging: {
      protocol: 'https',
      uri: 'ops-employees-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops-employees-api.goodeggs.com'
    }
  },
  'employees-api': {
    development: {
      protocol: 'https',
      uri: 'employees-api.goodeggs.test',
      port: 8010
    },
    test: {
      protocol: 'https',
      uri: 'employees-api-test.goodeggs.test',
      port: 8011
    },
    staging: {
      protocol: 'https',
      uri: 'employees-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'employees-api.goodeggs.com'
    }
  },
  'ops-purchase-orders-ui': {
    development: {
      protocol: 'https',
      uri: 'ops-purchase-orders.goodeggs.test',
      port: 8025
    },
    test: {
      protocol: 'https',
      uri: 'ops-purchase-orders-test.goodeggs.test',
      port: 8026
    },
    staging: {
      protocol: 'https',
      uri: 'ops-purchase-orders.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops-purchase-orders.goodeggs.com'
    }
  },
  'purchase-orders-ui': {
    development: {
      protocol: 'https',
      uri: 'purchase-orders.goodeggs.test',
      port: 8025
    },
    test: {
      protocol: 'https',
      uri: 'purchase-orders-test.goodeggs.test',
      port: 8026
    },
    staging: {
      protocol: 'https',
      uri: 'purchase-orders.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'purchase-orders.goodeggs.com'
    }
  },
  'ops-purchase-orders-api': {
    development: {
      protocol: 'https',
      uri: 'ops-purchase-orders-api.goodeggs.test',
      port: 8030
    },
    test: {
      protocol: 'https',
      uri: 'ops-purchase-orders-api-test.goodeggs.test',
      port: 8031
    },
    staging: {
      protocol: 'https',
      uri: 'ops-purchase-orders-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops-purchase-orders-api.goodeggs.com'
    }
  },
  'purchase-orders-api': {
    development: {
      protocol: 'https',
      uri: 'purchase-orders-api.goodeggs.test',
      port: 8030
    },
    test: {
      protocol: 'https',
      uri: 'purchase-orders-api-test.goodeggs.test',
      port: 8031
    },
    staging: {
      protocol: 'https',
      uri: 'purchase-orders-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'purchase-orders-api.goodeggs.com'
    }
  },
  'ops-inventory-api': {
    development: {
      protocol: 'https',
      uri: 'inventory-api.goodeggs.test',
      port: 8040
    },
    test: {
      protocol: 'https',
      uri: 'inventory-api-test.goodeggs.test',
      port: 8041
    },
    staging: {
      protocol: 'https',
      uri: 'inventory-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'inventory-api.goodeggs.com'
    }
  },
  'ops-inventory-ui': {
    development: {
      protocol: 'https',
      uri: 'inventory.goodeggs.test',
      port: 8045
    },
    test: {
      protocol: 'https',
      uri: 'inventory-test.goodeggs.test',
      port: 8046
    },
    staging: {
      protocol: 'https',
      uri: 'inventory.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'inventory.goodeggs.com'
    }
  },
  'availability-api': {
    development: {
      protocol: 'https',
      uri: 'availability-api.goodeggs.test',
      port: 8060
    },
    test: {
      protocol: 'https',
      uri: 'availability-api-test.goodeggs.test',
      port: 8061
    },
    staging: {
      protocol: 'https',
      uri: 'availability-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'availability-api.goodeggs.com'
    }
  },
  'demand-prediction-api': {
    development: {
      protocol: 'https',
      uri: 'demand-prediction-api.goodeggs.test',
      port: 8090
    },
    test: {
      protocol: 'https',
      uri: 'demand-prediction-api-test.goodeggs.test',
      port: 8091
    },
    staging: {
      protocol: 'https',
      uri: 'demand-prediction-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'demand-prediction-api.goodeggs.com'
    }
  },
  'pick-api': {
    development: {
      protocol: 'https',
      uri: 'pick-api.goodeggs.test',
      port: 9010
    },
    test: {
      protocol: 'https',
      uri: 'pick-api-test.goodeggs.test',
      port: 9011
    },
    staging: {
      protocol: 'https',
      uri: 'pick-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'pick-api.goodeggs.com'
    }
  },
  'shipping-api': {
    development: {
      protocol: 'https',
      uri: 'shipping-api.goodeggs.test',
      port: 9020
    },
    test: {
      protocol: 'https',
      uri: 'shipping-api-test.goodeggs.test',
      port: 9021
    },
    staging: {
      protocol: 'https',
      uri: 'shipping-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'shipping-api.goodeggs.com'
    }
  },
  'fulfillment-ui': {
    development: {
      protocol: 'https',
      uri: 'fulfillment.goodeggs.test',
      port: 9030
    },
    test: {
      protocol: 'https',
      uri: 'fulfillment-test.goodeggs.test',
      port: 9031
    },
    staging: {
      protocol: 'https',
      uri: 'fulfillment.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'fulfillment.goodeggs.com'
    }
  },
  'fulfillment-options-api': {
    development: {
      protocol: 'https',
      uri: 'fulfillment-options-api.goodeggs.test',
      port: 9040
    },
    test: {
      protocol: 'https',
      uri: 'fulfillment-options-api-test.goodeggs.test',
      port: 9041
    },
    staging: {
      protocol: 'https',
      uri: 'fulfillment-options-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'fulfillment-options-api.goodeggs.com'
    }
  },
  'it-accounts-ui': {
    development: {
      protocol: 'https',
      uri: 'it-accounts-ui.goodeggs.test',
      port: 9050
    },
    test: {
      protocol: 'https',
      uri: 'it-accounts-ui-test.goodeggs.test',
      port: 9051
    },
    staging: {
      protocol: 'https',
      uri: 'it-accounts-ui.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'it-accounts-ui.goodeggs.com'
    }
  },
  'it-accounts-api': {
    development: {
      protocol: 'https',
      uri: 'it-accounts-api.goodeggs.test',
      port: 9060
    },
    test: {
      protocol: 'https',
      uri: 'it-accounts-api-test.goodeggs.test',
      port: 9061
    },
    staging: {
      protocol: 'https',
      uri: 'it-accounts-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'it-accounts-api.goodeggs.com'
    }
  },
  'pick-triage-api': {
    development: {
      protocol: 'https',
      uri: 'pick-triage-api.goodeggs.test',
      port: 9070
    },
    test: {
      protocol: 'https',
      uri: 'pick-triage-api-test.goodeggs.test',
      port: 9071
    },
    staging: {
      protocol: 'https',
      uri: 'pick-triage-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'pick-triage-api.goodeggs.com'
    }
  },
  'pick-triage-ui': {
    development: {
      protocol: 'https',
      uri: 'pick-triage.goodeggs.test',
      port: 9075
    },
    test: {
      protocol: 'https',
      uri: 'pick-triage-test.goodeggs.test',
      port: 9076
    },
    staging: {
      protocol: 'https',
      uri: 'pick-triage.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'pick-triage.goodeggs.com'
    }
  },
  'gather-ui': {
    development: {
      protocol: 'https',
      uri: 'gather.goodeggs.test',
      port: 9085
    },
    test: {
      protocol: 'https',
      uri: 'gather-test.goodeggs.test',
      port: 9086
    },
    staging: {
      protocol: 'https',
      uri: 'gather.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'gather.goodeggs.com'
    }
  },
  'prep-ui': {
    development: {
      protocol: 'https',
      uri: 'prep.goodeggs.test',
      port: 9065
    },
    test: {
      protocol: 'https',
      uri: 'prep-test.goodeggs.test',
      port: 9066
    },
    staging: {
      protocol: 'https',
      uri: 'prep.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'prep.goodeggs.com'
    }
  },
  'devices-api': {
    development: {
      protocol: 'https',
      uri: 'devices-api.goodeggs.test',
      port: 9090
    },
    test: {
      protocol: 'https',
      uri: 'devices-api-test.goodeggs.test',
      port: 9091
    },
    staging: {
      protocol: 'https',
      uri: 'devices-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'devices-api.goodeggs.com'
    }
  },
  'devices-ui': {
    development: {
      protocol: 'https',
      uri: 'devices.goodeggs.test',
      port: 9095
    },
    test: {
      protocol: 'https',
      uri: 'devices-test.goodeggs.test',
      port: 9096
    },
    staging: {
      protocol: 'https',
      uri: 'devices.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'devices.goodeggs.com'
    }
  },
  'merchandising-ui': {
    development: {
      protocol: 'http',
      uri: 'merchandising.goodeggs.test',
      port: 9100
    },
    test: {
      protocol: 'http',
      uri: 'merchandising.goodeggs.test',
      port: 9101
    },
    staging: {
      protocol: 'https',
      uri: 'merchandising.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'merchandising.goodeggs.com'
    }
  },
  'drive-api': {
    development: {
      protocol: 'https',
      uri: 'drive.goodeggs.test',
      port: 9110
    },
    test: {
      protocol: 'https',
      uri: 'drive-test.goodeggs.test',
      port: 9111
    },
    staging: {
      protocol: 'https',
      uri: 'drive.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'drive.goodeggs.com'
    }
  },
  'drive-ui': {
    development: {
      protocol: 'https',
      uri: 'drive.goodeggs.test',
      port: 9110
    },
    test: {
      protocol: 'https',
      uri: 'drive-test.goodeggs.test',
      port: 9111
    },
    staging: {
      protocol: 'https',
      uri: 'drive.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'drive.goodeggs.com'
    }
  },
  'fulfillment-options-ui': {
    development: {
      protocol: 'https',
      uri: 'fulfillment-options.goodeggs.test',
      port: 9120
    },
    test: {
      protocol: 'https',
      uri: 'fulfillment-options-test.goodeggs.test',
      port: 9121
    },
    staging: {
      protocol: 'https',
      uri: 'fulfillment-options.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'fulfillment-options.goodeggs.com'
    }
  },
  'catalog-api': {
    development: {
      protocol: 'https',
      uri: 'catalog-api.goodeggs.test',
      port: 9130
    },
    test: {
      protocol: 'http',
      uri: 'catalog-api.goodeggs.test',
      port: 9131
    },
    staging: {
      protocol: 'https',
      uri: 'catalog-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'catalog-api.goodeggs.com'
    }
  },
  login: {
    development: {
      protocol: 'http',
      uri: 'developer-login.goodeggs.test',
      port: 9140
    },
    test: {
      protocol: 'http',
      uri: 'ops.goodeggs.test',
      port: 8001
    },
    staging: {
      protocol: 'https',
      uri: 'ops.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops.goodeggs.com'
    }
  },
  'sms-api': {
    development: {
      protocol: 'http',
      uri: 'sms-api.goodeggs.test',
      port: 9150
    },
    test: {
      protocol: 'http',
      uri: 'sms-api.goodeggs.test',
      port: 9151
    },
    staging: {
      protocol: 'https',
      uri: 'sms-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'sms-api.goodeggs.com'
    }
  },
  'portal-ui': {
    development: {
      protocol: 'https',
      uri: 'hub.goodeggs.test',
      port: 9160
    },
    test: {
      protocol: 'https',
      uri: 'hub-test.goodeggs.test',
      port: 9161
    },
    staging: {
      protocol: 'https',
      uri: 'hub.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'hub.goodeggs.com'
    }
  }
};
var _default = sites;
exports.default = _default;
//# sourceMappingURL=site_list.js.map